import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=6bfee3e7"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports